import styled, { css } from 'styled-components'

import * as colors from '../constants/colors'

export const BACKGROUND_COLORS = {
  bandcamp: colors.TERTIARY_BANDCAMP,
  bluesky: colors.TERTIARY_BLUESKY,
  dailymotion: colors.TERTIARY_TIKTOK,
  discord: colors.TERTIARY_DISCORD,
  email: colors.PRIMARY_BLUE_500,
  facebook: colors.TERTIARY_FACEBOOK,
  instagram: colors.TERTIARY_INSTAGRAM,
  linkedin: colors.TERTIARY_LINKEDIN,
  linktree: colors.TERTIARY_LINKTREE,
  mastodon: colors.TERTIARY_MASTODON,
  soundcloud: colors.TERTIARY_SOUNDCLOUD,
  spotify: colors.TERTIARY_SPOTIFY,
  threads: colors.TERTIARY_TIKTOK,
  tiktok: colors.TERTIARY_TIKTOK,
  tumblr: colors.TERTIARY_TIKTOK,
  twitch: colors.TERTIARY_TWITCH,
  twitter: colors.TERTIARY_X,
  vimeo: colors.TERTIARY_VIMEO,
  website: colors.PRIMARY_BLUE_500,
  youtube: colors.TERTIARY_YOUTUBE,
}

export const Square = styled.div<{ platform: keyof typeof BACKGROUND_COLORS; size?: number }>`
  align-items: center;
  background-color: ${({ platform }) => BACKGROUND_COLORS[platform]};
  color: ${colors.PRIMARY_WHITE};
  display: flex;
  flex: 1 0 auto;
  justify-content: center;

  ${({ size = 21.5 }) => css`
    height: ${size * 2}px;
    width: ${size * 2}px;
    max-width: ${size * 2}px;
  `};
`
